// Emulates webpack's `require.context(dir, true)` for react_ujs.
//
// Vite's `import.meta.glob(pattern, { eager: true })` returns a map of
// filepath -> Module Namespace Object. react_ujs (current major) calls
// `reqctx("./" + filename)` where filename is the React component name
// (e.g. "./Public", "./pages/Home.Subkey"). Webpack's context resolved
// these via subtree walk + extension fallback.
//
// We must ALSO unwrap the default export here. react_ujs has an
// `if (component.__esModule)` branch, but Vite's frozen Module Namespace
// doesn't always expose `__esModule` enumerably, so the unwrap can miss
// and React ends up trying to render the namespace object as a component
// ("Element type is invalid"). Pre-unwrapping avoids that.
export function buildContext(globModules) {
  const map = {};
  for (const [filepath, mod] of Object.entries(globModules)) {
    const wpKey = filepath.replace(/^\.\.\/[^/]+\//, './');
    map[wpKey] = unwrap(mod);
  }

  const EXTENSIONS = ['.jsx', '.js', '.tsx', '.ts'];

  function tryResolve(key) {
    if (map[key] !== undefined) return map[key];
    for (const ext of EXTENSIONS) {
      if (map[key + ext] !== undefined) return map[key + ext];
    }
    const want = key.replace(/^\.\//, '');
    for (const k of Object.keys(map)) {
      const stripped = k.replace(/^\.\//, '').replace(/\.(jsx?|tsx?)$/, '');
      if (stripped === want) return map[k];
      const last = stripped.split('/').pop();
      if (last === want) return map[k];
    }
    return undefined;
  }

  const context = (key) => tryResolve(key);
  context.keys = () => Object.keys(map);
  return context;
}

function unwrap(mod) {
  if (mod == null) return mod;
  if (typeof mod === 'function') return mod;
  if (typeof mod === 'object' && 'default' in mod) return mod.default;
  return mod;
}
